import BaseEvent from './BaseEvent.js';
import { getOSM } from '../../OverworldAnimation.js';
import { DOWN, UP } from '../../constants.js';

export default class StarterPicked extends BaseEvent {
    constructor({
        identifier = 'starter_picked',
        isActive = false,
        complete = false,
        autoComplete = true,
        objectsIdentifiers = [
            'lab_rival',
            'lab_professor',
            'starter_pokeball_grass',
            'starter_pokeball_fire',
            'starter_pokeball_water',
        ],
    } = {}) {
        super({ identifier, isActive, complete, autoComplete, objectsIdentifiers });
    }

    static deserialize(data) {
        return new StarterPicked({
            isActive: data.isActive,
            complete: data.complete,
        });
    }

    executeActions() {
        const osm = getOSM();
        const professor = this.getObject('lab_professor');
        const rival = this.getObject('lab_rival');
        osm.script(() => {
            this.getObject('lab_professor').direction = DOWN;
        });
        osm.readText(`You both made great choices!`, { speaker: () => professor.name });
        osm.continueReading();
        osm.readText('Now, while I have you both here...');
        osm.continueReading();
        osm.readText('I would like to tell you a bit more about my project.');
        osm.continueReading();
        osm.readText('I know I said no strings attached, so feel free to go about your lives.');
        osm.continueReading();
        osm.readText('But please humor me for a bit!');
        osm.continueReading();
        osm.readText('As I said earlier, our beautiful Borikén region is full of Pokémon.');
        osm.continueReading();
        osm.readText('But as far as I know, Pokémon found here come from all over the world!');
        osm.continueReading();
        osm.readText('In fact, I don’t know of a single native species.');
        osm.continueReading();
        osm.readText('I wonder if they even exist at all...');
        osm.continueReading();
        osm.readText('In any case,');
        osm.continueReading();
        osm.readText(
            'upon my recent retirement from my post as a Move Researcher at Paldea’s Naranja Academy,'
        );
        osm.continueReading();
        osm.readText(
            'I decided to move here to the Borikén region and independently study the Pokémon in the region.'
        );
        osm.continueReading();
        osm.readText('And I have to say, I’m loving it already!');
        osm.continueReading();
        osm.readText('But I have so much to learn about the Pokémon in this region.');
        osm.continueReading();
        osm.readText('That’s where I need your help!');
        osm.continueReading();
        osm.script(() => {
            professor.showExclamationMark();
        });
        osm.delay(30);
        osm.readText('I see you are both carrying Pokédexes already. Amazing!');
        osm.continueReading();
        osm.readText('So how’s this?');
        osm.continueReading();
        osm.readText('I would like you both to stop by my Lab periodically to show me your progress.');
        osm.continueReading();
        osm.readText('In fact, I’ll reward you once again if you can show me 5 Pokédex entries!');
        osm.continueReading();
        osm.readText('This next reward won’t be a new Pokémon though!');
        osm.continueReading();
        osm.readText('But you both already know I’m a man of my word.');
        osm.continueReading();
        osm.script(() => {
            professor.showExclamationMark();
        });
        osm.delay(30);
        osm.readText('Oh! I think I have a few empty Pokéballs lying around!');
        osm.continueReading();
        osm.readText('Give me one second...');
        osm.finishReading();
        osm.moveNPCV2(professor, {
            x: professor.position.x + 64,
            y: professor.position.y - 32,
            z: 0,
        });
        osm.script(() => {
            professor.direction = UP;
        });
        osm.delay(30);
        osm.moveNPCV2(professor, {
            x: osm.player.position.x,
            y: osm.player.position.y - 16,
            z: 0,
        });
        osm.script(() => {
            professor.direction = DOWN;
        });
        osm.readText('There we go! 10 Pokéballs should do!', { speaker: () => professor.name });
        osm.continueReading();
        osm.readText('Alright! I declare my monologue done.');
        osm.continueReading();
        osm.readText('I’m finally going to enjoy my meal.');
        osm.continueReading();
        osm.readText(`So go ahead and catch some Pokémon!`);
        osm.continueReading();
        osm.readText(`I’ll be here if you need me.`);
        osm.continueReading();
        osm.readText(`Thanks Professor!`, { speaker: () => rival.name });
        osm.finishReading();
        osm.moveNPCV2(rival, {
            x: osm.player.position.x,
            y: osm.player.position.y + 16 * 6,
            z: osm.player.position.z,
        });
        osm.script(() => {
            professor.text = 'Go find some more Pokémon!';
            rival.position = {
                x: 0,
                y: 0,
                z: 0,
            };
            rival.visible = false;
        });
    }
}
